var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconBadgeWarning = function SvgIconBadgeWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    d: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zm0-13v4m.5 3.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0z",
    vectorEffect: "non-scaling-stroke"
  })));
};
export { SvgIconBadgeWarning as ReactComponent };
export default __webpack_public_path__ + "69ceaa43a824ceab00652e543234d5a1.svg";